import { Box } from "@mui/material";
import TypographyCompo from "../../components/Comman/TypographyCompo";
import { blackColor, white } from "../../config/ColorObj";

const OutletSummary = ({
    offerIndex,
    outlets,
    selectedOutlets,
    getSelectedOutletsCountForOffer,
}) => {
    const selectedOutletsList = outlets.filter((_, outletIndex) =>
        selectedOutlets[`${offerIndex}_${outletIndex}`]
    );

    const totalTaxableAmount = selectedOutletsList.reduce(
        (sum, outlet) => sum + Number(outlet.taxableAmount || 0),
        0
    );

    const totalTaxAmount = selectedOutletsList.reduce(
        (sum, outlet) => sum + Number(outlet.totalTaxAmt || 0),
        0
    );

    const grandTotal = selectedOutletsList.reduce(
        (sum, outlet) => sum + Number(outlet.totalAmount || 0),
        0
    );

    return (
        <Box
            sx={{
                mt: 2,
                width: "100%",
                px: 2,
                py: 1.5,
                backgroundColor: white,
                border: "1px solid #dcdcdc",
                borderRadius: "8px",
                overflowX: "auto",
            }}
        >
            {/* Title */}
            <TypographyCompo
                sx={{
                    fontSize: 14,
                    fontWeight: 600,
                    color: blackColor,
                    mb: 1,
                }}
            >
                Selected Outlets Summary ({getSelectedOutletsCountForOffer(offerIndex, outlets)})
            </TypographyCompo>

            {/* Row */}
            <Box
                sx={{
                    display: "flex",
                    flexWrap: "nowrap",
                    gap: 2,
                    width: "100%",
                }}
            >
                {/* Total Taxable Amount */}
                <Box
                    sx={{
                        flex: 1,
                        minWidth: 280,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        px: 1.5,
                        py: 0.75,
                        border: "1px solid #ccc",
                        borderRadius: "6px",
                        backgroundColor: white,
                    }}
                >
                    <TypographyCompo sx={{ fontSize: 13, color: blackColor }}>
                        Total Taxable Amount :
                    </TypographyCompo>
                    <TypographyCompo sx={{ fontSize: 14, fontWeight: 600, color: blackColor }}>
                        ₹{totalTaxableAmount.toFixed(2)}
                    </TypographyCompo>
                </Box>

                {/* Total Tax Amount */}
                <Box
                    sx={{
                        flex: 1,
                        minWidth: 260,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        px: 1.5,
                        py: 0.75,
                        border: "1px solid #ccc",
                        borderRadius: "6px",
                        backgroundColor: white,
                    }}
                >
                    <TypographyCompo sx={{ fontSize: 13, color: blackColor }}>
                        Total Tax Amount :
                    </TypographyCompo>
                    <TypographyCompo sx={{ fontSize: 14, fontWeight: 600, color: blackColor }}>
                        ₹{totalTaxAmount.toFixed(2)}
                    </TypographyCompo>
                </Box>

                {/* Grand Total */}
                <Box
                    sx={{
                        flex: 1.2,
                        minWidth: 300,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        px: 1.5,
                        py: 0.75,
                        border: "2px solid #000",
                        borderRadius: "6px",
                        backgroundColor: white,
                    }}
                >
                    <TypographyCompo sx={{ fontSize: 13, fontWeight: 600, color: blackColor }}>
                        Grand Total :
                    </TypographyCompo>
                    <TypographyCompo sx={{ fontSize: 15, fontWeight: 700, color: blackColor }}>
                        ₹{grandTotal.toFixed(2)}
                    </TypographyCompo>
                </Box>
            </Box>
        </Box>
    );
};

export default OutletSummary;